import React from 'react'
// import Carousel from '../carousel/Carousel'
// import AssciatePartners from "./AssociatePartners"
import "./home.css"
// import ClientsAsGallery from "./ClientsAsGallery"
import Productlist from './productlist'
import IndustrySolutions from './IndustrySolutions'
import { Services } from './Services'

export const Home = () => {
  return (
    <div >
      {/* <Carousel /> */}

      {/* our intro */}

       <IndustrySolutions/>
     <Productlist/>
     <Services/>
    
      {/* <ClientsAsGallery/> */}
      



    </div>



  )
}
